export default "<div id=\"{{fullId}}\"></div>\n";